import React from "react";
import { useTranslation } from "../i18n";
import "../styles/SuccessModal.css";
import ExternalLinkIcon from "./ExternalLinkIcon";
import { useNavigate } from 'react-router-dom';

const SuccessModal = ({ isNew, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="success-overlay" onClick={onClose}>
      <div className="success-modal" onClick={(e) => e.stopPropagation()}>
        {}
        <div className="success-accent" />

        <h2 className="success-title">
          {isNew ? t("success.titleNew") : t("success.titleUpdate")}
        </h2>
        <p className="success-message">
          {isNew ? t("success.messageNew") : t("success.messageUpdate")}
        </p>

        {}
        <div className="success-ctas">
          <a
            className="success-cta success-cta--instagram"
            href="https://www.instagram.com/mixordiamusic"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="success-cta-text">{t("success.ctaInstagram")}</span>
            <ExternalLinkIcon className="success-cta-arrow" />
          </a>
          <button
            className="success-cta"
            onClick={() => {
              onClose && onClose();
              navigate('/events');
            }}
          >
            <span className="success-cta-text">{t("success.ctaGallery")}</span>
            <ExternalLinkIcon className="success-cta-arrow" />
          </button>
          <button
            className="success-cta"
            onClick={() => {
              onClose && onClose();
              navigate('/showcase');
            }}
          >
            <span className="success-cta-text">{t("success.ctaPartners")}</span>
            <ExternalLinkIcon className="success-cta-arrow" />
          </button>
        </div>

        <button className="success-close-btn" onClick={onClose} aria-label={t("success.close")}>
          ✕
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
